import styled from "styled-components";

export const PopupFooterButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const FullScreenPopupContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  margin-top: 51px;
  padding: 30px;
  height: 100%;
`;

export const FullScreenPopupTitle = styled.div`
  font-size: 24px;
  line-height: 32px;
  font-weight: 500;
  color: ${({ theme }) => theme.white};
  text-align: center;
`;
